import React, { Component } from 'react'
import PropTypes from 'prop-types';
import APIManager from 'modules/common/apiManager';
import SelectWithSearch from 'modules/common/components/form/SelectWithSearch';
// import SelectWithSearch from './form/SelectWithSearch';
export class SelectFilterAPI extends Component {
  constructor(props){
    super(props);
    this.mAPI = new APIManager();
    this.state = {
      loading : false,
      limit : props.limit || 20,
      options : props.options || [],
    }
    this.timer = "";
    this.getData = this.getData.bind(this);
    this.onSearch = this.onSearch.bind(this);
    // this.getData();
  }
  getData( search ){
    const { dataUrl } = this.props
    let _this  = this;
    let searchQuery = "";
    if (search) {
      searchQuery = `&search=${search}`;
    }
    _this.setState({loading : true});
    this.mAPI.sendGetAPI(
      `${dataUrl}?limit=${this.state.limit}&page_no=1${searchQuery}`,
      data => {
        if (data && data.data) {
          // that.setState({ listData: data.data });
          let options = [];
          data.data.map(data => {
            options.push({
              value: data._id,
              data : data,
              label: data.name || data.phone_number
            });
          });
          _this.setState({"options":options,loading : false});
        } else {
          _this.setState({"options":[],loading : false});
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
        if (data) {
          _this.setState({"options":[],loading : false});
        } else {
          _this.setState({"options":[],loading : false});
        }
      }
    );
  }
  onSearch( search ) {
    let _this = this; 
    search = search == "reload" ? "" : search;
    console.log("onSearch ---", search);
    clearTimeout(this.timer);
    _this.setState({"loading":true})
    _this.timer = setTimeout(()=>{
      _this.getData( search );
    },350)
  }
  render() {
    const { selected, label, name, onSelect, multi, initialValues  } = this.props
    console.log('this.state.options',this.props);
    return (
      <SelectWithSearch
        loading={this.state.loading}
        initialValues={initialValues}
        selectedValues={selected}
        totalOptions={this.state.options}
        label={label}
        onSelect={onSelect}
        name={name}
        search={this.onSearch}
        multi={multi}
        customOption=""
        showAvatar={false}
      />
    )
  }
}
SelectFilterAPI.contextTypes = {
  __: PropTypes.func
};

export default SelectFilterAPI;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/SelectFilterAPI.js